import { v4 as uuidv4 } from 'uuid';

/**
 * function to take array and generate a unique key attached with array
 * For Example: input : [ [1,2,3,4,5], [2,0,6,4,3], [1,2,3,4,5] ]
 * output : [ 1: [1,2,3,4,5], 2: [2,0,6,4,3], 3: [1,2,3,4,5] ]
 * @param {ref} string reference string
 * @param {array} array that you want to create unique key
 */
const generateKeyWithArray = (ref, array) => {
  const obj = {};
  array.forEach(item => {
    obj[`${ref}${uuidv4()}`] = item;
  });
  return obj;
};
/**
 * Split array into parts given by parameter
 * For Example: Array has 10 element and if you want to break array into 2/3 part
 * @param {Array} array array you want to breakdown
 * @param {Number} parts in how many number of parts you want to breakdown
 */
const splitArrayIntoParts = (array, numberOfParts) => {
  const quot = Math.floor(array.length / numberOfParts);
  const rem = array.length % numberOfParts;
  const parts = [];
  for (let i = 0; i < numberOfParts; ++i) {
    const begin = i * quot + Math.min(rem, i);
    const end = begin + quot + (i < rem);
    parts.push(array.slice(begin, end));
  }
  const finalResult = generateKeyWithArray('material_', parts);
  return finalResult;
};

export default splitArrayIntoParts;
